import { render, staticRenderFns } from "./AddTypeOptionModal.vue?vue&type=template&id=4731a0b3&scoped=true&lang=html"
import script from "./AddTypeOptionModal.vue?vue&type=script&lang=js"
export * from "./AddTypeOptionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4731a0b3",
  null
  
)

export default component.exports